module.exports = __webpack_public_path__ + "2e92e7a7504acc446527282d1b1fe600.svg";


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/referral/modals/plaid_logo.svg
// module id = 1009
// module chunks = 0